/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  ResultDto,
  UpdateResultDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    ResultDtoFromJSON,
    ResultDtoToJSON,
    UpdateResultDtoFromJSON,
    UpdateResultDtoToJSON,
} from '../models/index';

export interface GetResultByMeasurementIdRequest {
    measurementId: string;
}

export interface UpdateResultRequest {
    id: string;
    updateResultDto?: UpdateResultDto;
}

/**
 * 
 */
export class ResultsApi extends runtime.BaseAPI {

    /**
     */
    async getResultByMeasurementIdRaw(requestParameters: GetResultByMeasurementIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDto>> {
        if (requestParameters.measurementId === null || requestParameters.measurementId === undefined) {
            throw new runtime.RequiredError('measurementId','Required parameter requestParameters.measurementId was null or undefined when calling getResultByMeasurementId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/results/{measurementId}`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters.measurementId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async getResultByMeasurementId(requestParameters: GetResultByMeasurementIdRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getResultByMeasurementIdRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ResultDto>(response, errorHandlers);
    }

    /**
     */
    async updateResultRaw(requestParameters: UpdateResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateResult.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/results/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateResultDtoToJSON(requestParameters.updateResultDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateResult(requestParameters: UpdateResultRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateResultRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
